import { matchRoutes } from 'react-router-dom'

/**
 * The shape the expense API generates for an expense uuid: `exp_` then letters
 * and digits (30 of them today; the length isn't checked, as the API's own
 * `@Uuid("exp")` check sets none). Every real id fits this, and anything else
 * on an expense route is not an expense.
 */
const EXPENSE_UUID = /^exp_[A-Za-z0-9]+$/

/**
 * Every page where Ash can use what's on screen, as route patterns matched the
 * way `<Routes>` matches them. A route not listed here sends `page: null`.
 *
 * Each `page` builds what Ash is told from the route's params: a pointer, never
 * the expense itself, which Ash fetches under the member's own token.
 */
const expenseDetailPage = ({ expenseUuid }) =>
  EXPENSE_UUID.test(expenseUuid)
    ? { kind: 'expense_detail', expenseUuid }
    : null

const ASH_PAGES = [
  { path: '/expenses', page: () => ({ kind: 'expense_list' }) },
  { path: '/expenses/:expenseUuid', page: expenseDetailPage },
  // The member-app expense page redirects here when it does not render (flag
  // off, expense not CLOSED); the SPA serves the same detail page at this path.
  { path: '/expenses/legacy/:expenseUuid', page: expenseDetailPage },
]

/**
 * What's on screen, for Ash: sent as `page` on every `SET_CONFIG`.
 *
 * @param {string} [pathname] - The route the member is on.
 * @returns {{ kind: 'expense_detail'; expenseUuid: string }
 *   | { kind: 'expense_list' }
 *   | null}
 */
export const getAshPage = (pathname = '') => {
  const [match] = matchRoutes(ASH_PAGES, pathname) ?? []
  return match ? match.route.page(match.params) : null
}
